module.exports = __webpack_public_path__ + "img/transh.9836b6df.svg";